(() => {
  const CSRF_STORAGE_KEY = 'norphe_contact_csrf_token';

  const generateToken = () => {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
  };

  const syncCsrfToken = (form) => {
    const csrfInput = form.querySelector('[data-contact-csrf]');
    if (!csrfInput) return;
    let token = sessionStorage.getItem(CSRF_STORAGE_KEY);
    if (!token) {
      token = generateToken();
      sessionStorage.setItem(CSRF_STORAGE_KEY, token);
    }
    csrfInput.value = token;
  };

  const initContactFormSecurity = (form) => {
    if (!form) return;
    syncCsrfToken(form);
    if (form.dataset.contactSecurityInit === 'true') return;
    form.dataset.contactSecurityInit = 'true';
  };

  const isHoneypotValid = (form) => {
    const honeypot = form.querySelector('[data-contact-honeypot]');
    if (!honeypot) return true;
    return honeypot.value.trim() === '';
  };

  const isCsrfValid = (form) => {
    syncCsrfToken(form);
    const csrfInput = form.querySelector('[data-contact-csrf]');
    const stored = sessionStorage.getItem(CSRF_STORAGE_KEY);
    return Boolean(csrfInput && stored && csrfInput.value === stored);
  };

  const hasShopifyContactFormFields = (form) => {
    const formType = form.querySelector('input[name="form_type"]');
    const utf8 = form.querySelector('input[name="utf8"]');
    return formType?.value === 'contact' && Boolean(utf8?.value);
  };

  /**
   * @returns {'ok' | 'honeypot' | 'csrf' | 'shopify_form'}
   */
  const getContactFormSecurityIssue = (form) => {
    if (!form) return 'csrf';
    if (!isHoneypotValid(form)) return 'honeypot';
    if (!isCsrfValid(form)) return 'csrf';
    if (!hasShopifyContactFormFields(form)) return 'shopify_form';
    return 'ok';
  };

  const isContactFormSecurityValid = (form) => getContactFormSecurityIssue(form) === 'ok';

  const blockSubmitIfInsecure = (form, event) => {
    syncCsrfToken(form);
    const issue = getContactFormSecurityIssue(form);
    if (issue === 'ok') return false;

    if (issue === 'shopify_form') {
      console.warn('[contact-form] Champs Shopify manquants (form_type / utf8).');
    }

    event?.preventDefault?.();
    event?.stopPropagation?.();
    event?.stopImmediatePropagation();

  /* Honeypot uniquement : blocage silencieux. CSRF régénéré automatiquement (pas de redirection). */
    return true;
  };

  const resetCsrfToken = () => {
    sessionStorage.removeItem(CSRF_STORAGE_KEY);
    const form = document.getElementById('ContactForm');
    if (form) syncCsrfToken(form);
  };

  window.contactFormSecurity = {
    init: initContactFormSecurity,
    syncCsrfToken,
    resetCsrfToken,
    isValid: isContactFormSecurityValid,
    getIssue: getContactFormSecurityIssue,
    blockSubmitIfInsecure,
  };

  const form = document.getElementById('ContactForm');
  if (form) {
    initContactFormSecurity(form);

    const guard = (event) => blockSubmitIfInsecure(form, event);

    form.addEventListener(
      'click',
      (e) => {
        const submitter = e.target.closest?.('button[type="submit"], input[type="submit"]');
        if (!submitter || !form.contains(submitter)) return;
        guard(e);
      },
      true
    );

    form.addEventListener('submit', guard, true);
  }
})();
